import Button from '@ergeon/core-components/exports/Button.ts';
import { CheckIcon, ExclamationTriangleIcon } from '@ergeon/icons/hero/micro';

interface PermissionChipProps {
  name: string;
  granted: boolean;
  onEnable(): void;
}

/**
 * One permission in the lobby's readiness row. Both states are the same button
 * so the row keeps one rhythm: tapping re-asks for the permission, which fixes
 * a missing one and re-checks a granted one against the browser's own site
 * controls, where the customer may have just revoked it.
 */
export default function PermissionChip({ name, granted, onEnable }: PermissionChipProps) {
  const Icon = granted ? CheckIcon : ExclamationTriangleIcon;
  const ariaLabel = granted ? `${name} is on` : `${name} is off — enable it`;
  const flavor = granted ? 'success' : 'warning';
  const taste = granted ? 'line' : 'solid';

  return (
    <li className="flex">
      <Button
        ariaLabel={ariaLabel}
        className="gap-2"
        flavor={flavor}
        onClick={onEnable}
        shape="circle"
        size="medium"
        taste={taste}>
        <Icon className="size-4 shrink-0" />
        {/* Constant label, constant width: the icon and flavor carry the
            state, so a grant never re-wraps the chip row. */}
        {name}
      </Button>
    </li>
  );
}
